<div class="tec-page">
    <div class="tec-header">
      <h2 style="color: black;">Transformer Loss & Efficiency Calculator</h2>
     <div style="display: flex;justify-content: right;">
      <button class="tec-btn tec-btn--secondary" (click)="downloadReport()">Download Report</button>
   </div>
    </div>
    <div class="tec-top-row">
      <div class="tec-inputs">
        <div class="tec-field">
          <ng-select [items]="transformerList_E" bindLabel="transformerDetail" placeholder="Transformer"
            [(ngModel)]="selectedTransformer_E" (change)="onTransformerChange($event)" [clearable]="false" appendTo="body"
            [dropdownPosition]="'auto'">
          </ng-select>
        </div>
        <div class="tec-field floating-label">
          <input type="number" min="0" step="0.1" [(ngModel)]="resistanceMilliohm" (input)="onInputsChanged()" />
          <label>Resistance (Ω)</label>
        </div>
        <div class="tec-field floating-label">
          <input type="number" min="0" step="1" [(ngModel)]="ironLossWatts" (input)="onInputsChanged()" />
          <label>Iron Loss (W)</label>
        </div>
        <div class="tec-field floating-label">
          <input type="number" min="0" step="0.1" [(ngModel)]="strayLossPercent" (input)="onInputsChanged()" />
          <label>Stray Loss (%)</label>

        <div style="display: flex;justify-content: right;">
          <button class="tec-btn tec-btn--primary"
          (click)="saveReadings(selectedTransformer_E.transformerid, resistanceMilliohm, ironLossWatts, strayLossPercent)">Save
          Readings</button>
          </div>
        </div>
      </div>
    </div>
  <div class="row heightMat">
    <div class="col-md-5" style="padding: 0px;">
     
              <div *ngIf="isLoading" class="table-loading">
                <div class="loading-spinner"></div>
                <p>Loading...</p>
              </div>
          
              <table class="custom-scroll-table">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Copper (kW)</th>
                    <th>Stray (kW)</th>
                    <th>Total Loss (kW)</th>
                    <th>Final Loss (kW)</th>
                    <th>Output (kW)</th>
                    <th>Efficiency (%)</th>
                    <th>Load Factor(%)</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="!isLoading && readings?.length > 0; else noData">
                    <tr *ngFor="let r of getReversedReadings()" 
                        [class.active]="r.id===selectedReadingId"
                        (click)="selectReading(r.id)">
                      <td>{{ r.timestamp | date:'HH:mm' }}</td>
                      <td>{{ r.copperLossKW | number:'1.1-3' }}</td>
                      <td>{{ r.strayLossKW | number:'1.1-3' }}</td>
                      <td>{{ r.totalLossKW | number:'1.1-3' }}</td>
                      <td>{{ r.finalTotalLossKW | number:'1.1-3' }}</td>
                      <td>{{ r.outputPowerKW | number:'1.1-2' }}</td>
                      <td>{{ r.efficiencyPercent | number:'1.1-2' }}</td>
                      <td>{{ r.lf | number:'1.1-2' }}</td>
                    </tr>
                  </ng-container>
                  <ng-template #noData>
                    <tr *ngIf="!isLoading">
                      <td colspan="7" style="text-align:center; padding: 14px; color:#64748b; font-style: italic;">
                        No data available
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
          
    </div> <!--
        <h3>Readings</h3>
        <div class="table-wrapper" >
          <div *ngIf="isLoading" class="table-loading">
            <div class="loading-spinner"></div>
            <p>Loading...</p>
          </div>
          <div>
          <table class="tec-table" style="overflow: scroll; " >
            <thead>
              <tr>
                <th>Time</th>
                <th>Copper (kW)</th>
                <th>Stray (kW)</th>
                <th>Total Loss (kW)</th>
                <th>Final Loss (kW)</th>
                <th>Output (kW)</th>
                <th>Efficiency (%)</th>
              </tr>
            </thead>
            <tbody >
              <ng-container *ngIf="!isLoading && readings?.length > 0; else noData">
                <tr *ngFor="let r of getReversedReadings()" [class.active]="r.id===selectedReadingId"
                  (click)="selectReading(r.id)">
                  <td>{{ r.timestamp | date:'HH:mm' }}</td>
                  <td>{{ r.copperLossKW | number:'1.1-3' }}</td>
                  <td>{{ r.strayLossKW | number:'1.1-3' }}</td>
                  <td>{{ r.totalLossKW | number:'1.1-3' }}</td>
                  <td>{{ r.finalTotalLossKW | number:'1.1-3' }}</td>
                  <td>{{ r.outputPowerKW | number:'1.1-2' }}</td>
                  <td>{{ r.efficiencyPercent | number:'1.1-2' }}</td>
                </tr>
              </ng-container>
              <ng-template #noData>
                <tr *ngIf="!isLoading">
                  <td colspan="7" style="text-align:center; padding: 14px; color:#64748b; font-style: italic;">
                    No data available
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>-->
    <div class="col-md-4 " style=" padding: 0% 0.5% 0% 0.5%;">
      <h3>Loss Parameters</h3>
        <div class="chart-wrapper" >
          <div *ngIf="isLoading" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading data...</p>
          </div>
          <div *ngIf="!isLoading && readings?.length === 0" class="no-data-container">
            <p>No data to show in graph</p>
          </div>
          <plotly-plot *ngIf="!isLoading && readings?.length > 0" [data]="lossChartData" [layout]="lossChart.layout"
            [config]="lossChart.config" class="plotly-chart">
          </plotly-plot>
        </div>
    </div>
   <div class="col-md-3 " style="padding: 0% 1.5% 0% 0%;">
     <h3>Power & Efficiency</h3>
        <div class="chart-wrapper" >
          <div *ngIf="isLoading" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading data...</p>
          </div>
          <div *ngIf="!isLoading && readings?.length === 0" class="no-data-container">
            <p>No data to show in graph</p>
          </div>
          <plotly-plot *ngIf="!isLoading && readings?.length > 0" [data]="mainChartData" [layout]="mainChart.layout"
            [config]="mainChart.config" class="plotly-chart">
          </plotly-plot>
        </div>
    </div>
  </div>